import 'react-circular-progressbar/dist/styles.css';

import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';

import { useTranslation } from '@lyearn/i18n';
import { CloseFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, IconButton, Tooltip } from '@lyearn/ui';
import { MediaDisplay, MediasProps } from '@/components/LegacyMediaContainer/types';

import { p3 } from './styles';

const PROGRESS_STYLES = buildStyles({
  pathColor: 'var(--interactive-primary)',
});

const RemoveAction: React.FC<{
  media: MediasProps['media'];
  onAction?: () => void;
  displayMode?: MediaDisplay;
}> = ({ media: { progress }, displayMode, onAction }) => {
  const { t } = useTranslation();
  return (
    <Box
      className={cn(
        'flex h-20 w-20 items-center justify-center rounded border border-border bg-bg-primary',
        { hidden: !progress && displayMode === MediaDisplay.GRID },
        progress ? p3 : 'p-0',
      )}>
      {progress ? (
        <CircularProgressbar strokeWidth={12.5} styles={PROGRESS_STYLES} value={50} />
      ) : (
        <Tooltip title={t('Common:Actions.Remove')}>
          <IconButton
            Icon={CloseFill}
            appearance="secondary"
            size="xxs"
            variant="outlined"
            onClick={onAction}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default RemoveAction;
